import classNames from 'classnames';

interface ReturnType {
  className: string;
  invalid: boolean;
  'aria-invalid'?: boolean;
}

function getValidationProps(error: any, touched: boolean, className?: string): ReturnType {
  const isInvalid = touched && !!error;
  return {
    className: classNames({ 'is-invalid': isInvalid }, className),
    invalid: isInvalid,
    'aria-invalid': isInvalid || undefined,
  };
}

export { getValidationProps };
